export function invoiceShowTabularColumn() {
  return [
    {
      name: 'id',
      title: 'شماره فاکتور'
    },
    {
      name: 'status',
      title: 'وضعیت'
    },
    {
      name: 'amount',
      title: 'مقدار'
    },
    {
      name: 'discount',
      title: 'تخفیف کل'
    },
    {
      name: 'net_payable',
      title: 'مبلغ خالص'
    },
    {
      name: 'tax',
      title: 'مالیات'
    },
    {
      name: 'payable',
      title: 'قابل پرداخت'
    },
    {
      name: 'due_date',
      title: 'تاریخ سررسید'
    },
    {
      name: 'paid_at',
      title: 'تاریخ پرداخت'
    },
    {
      name: 'model_type',
      title: 'نوع فاکتور'
    }
    // {
    //   name: 'actions',
    //   title: ''
    // }
  ]
}